import { render } from "./ShopBox.vue?vue&type=template&id=1f946ade"
import script from "./ShopBox.vue?vue&type=script&lang=js"
export * from "./ShopBox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__